
<div class="row">
  <div class="col-md-12">
    <div class="card height-800">
      <div class="card-header margin-top-10 wh-header border-bottom-1px">

        <div class="row ">
          <div class="col-md-12 text-align-left">
            <label class="label-size-2">IVF Cycle Activities(Master)</label>
          </div>

        </div>

      </div>
      <div class="card-body padding-top-0px padding-bottom-0px">
        <div class="row">
          <div class="col-md-3 border-right">
            <div class="card">
              <div class="card-header wh-header">
                <div class="row ">
                  <div class="col-md-9 text-align-left">
                    <label class="label-size-2">Template Name</label>
                  </div>
                  <div class="col-md-3">
                    <button type="button"
                            class="btn  btn-sm button-ivfactivity  background-primary border-all-secondary float-right" id="FileUpload" (click)="Addactivity()"
                            name="upload">
                      <i class="fas fa-plus font-size-11"></i>
                    </button>
                  </div>

                </div>
                <div class="row">
                  <div class="col-md-12">
                    <input type="text" class="form-control" placeholder="Search" (input)="criteriaChange($event.target.value)">
                  </div>
                </div>
              </div>
              <div class="card-body padding-top-0px">
                <div class="table-component margin-bottom-0px">
                  <div class="table-responsive overflow-x-hidden">

                    <table class="table table-striped margin-left-zero">

                      <thead class="">
                        <!--<tr class="bordertop">
                          <th class="padding-left-2px padding-right-2px"></th>
                          <th class="padding-left-2px padding-right-2px width-35px"></th>



                        </tr>-->
                      </thead>
                      <tbody class="table-body" id="edit-link">
                        <tr class="border-bottom-0px" *ngFor="let l of CurrentIvfPlanTemplateController ; let RowIndex = index " >
                          <td class="padding-top-4px padding-bottom-4px nav-link-hand padding-left-0px padding-right-0px" (click)="ViewSelectedTemplate(l)">{{l.Protocol}}({{l.CycleType}})</td>
                                                 
                          <td class="padding-top-4px padding-bottom-4px padding-left-0px padding-right-0px">
                            <div class="test-icons">
                              <a (click)="Editactivity(l)" class="nav-link-hand education-navlink  color-Assign" title="Edit">
                                <i class="fas fa-pencil-alt nav-link-hand"></i><!--<span class="badge"></span>-->
                              </a>
                              <a class="nav-link-hand padding-left-5px font-size-16px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                            </div>
                            <!--<a (click)="Editactivity(l)" class="display-edit"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand color-Assign"></i></a>-->
                          </td>

                        </tr>
                      
                      </tbody>

                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-9" *ngIf="ShowActivity">
            <div class="card" *ngIf="SelectedTemplate">
              <div class="card-header wh-header">
                <div class="row ">
                  <div class="col-md-8">
                    <div class="row">
                      <div class="col-md-2 padding-right-0px">
                        <label class="label-size-2 font-color-secondary">Activities of</label>
                      </div>
                      :
                      <div class="col-md-7 text-align-left">
                        <label class="label-size-2">{{SelectedTemplate.Protocol}}</label>
                      </div>

                    </div>
                  </div>
                 
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-2 padding-top-5px">
                        <button type="button"
                                class="btn  btn-sm button-ivfactivity  background-primary border-all-secondary float-right" id="FileUpload" (click)="Addactivities()"
                                name="upload">
                          <i class="fas fa-plus font-size-11"></i>
                        </button>
                      </div>
                      <div class="col-md-10">
                        <input type="text" class="form-control" placeholder="Search" (input)="criteriaChange($event.target.value)">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body padding-top-0px">
                <div class="table-component margin-bottom-0px">
                  <div class="table-responsive overflow-x-hidden">

                    <table class="table table-striped margin-left-zero">

                      <thead class="">
                        <tr class="bordertop">

                          <th class="padding-left-2px padding-right-2px width-35px">S.No</th>

                          <th class="">Activity Description</th>

                          <th class="">Applicable to</th>
                          <th class="">Type</th>
                          <th class="">SVC Code</th>
                          <th class="">DOC</th>
                          <th class="">Seq</th>
                          <th class="padding-left-2px padding-right-2px"></th>
                        </tr>
                      </thead>
                      <tbody class="table-body">
                        <tr class="border-bottom-0px" *ngFor="let l of CurrentIvfPlanActivityTemplateController ; let RowIndex = index " >
                          <td class="padding-top-4px padding-bottom-4px">{{RowIndex+1}}</td>
                          <td class="padding-top-4px padding-bottom-4px">{{l.ActivityDescription}}</td>

                          <td class="padding-top-4px padding-bottom-4px">{{l.ApplicableTo}}</td>

                          <td class="padding-top-4px padding-bottom-4px">{{l.ActivityType}}</td>
                          <td class="padding-top-4px padding-bottom-4px">{{l.ServiceCode}}</td>
                          <td class="padding-top-4px padding-bottom-4px">{{l.DOC}}</td>
                          <td class="padding-top-4px padding-bottom-4px">{{l.SeqNo}}</td>
                          <td class="padding-top-4px padding-bottom-4px">
                            <!--<a (click)="Editactivities(l)"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand color-Assign"></i></a>-->
                            <div class="test-icons float-right">
                              <a (click)="Editactivities(l)" class="nav-link-hand education-navlink  color-Assign" title="Edit">
                                <i class="fas fa-pencil-alt nav-link-hand"></i><!--<span class="badge"></span>-->
                              </a>
                              <a class="nav-link-hand padding-left-5px font-size-16px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                            </div>
                          </td>
                        </tr>
                        
                      </tbody>

                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




